import {TestRunDetail} from './generated.model';

export const ACTIVE_STATES = ['pending', 'started', 'building', 'running'];

export function isTestRunActive(testrun: TestRunDetail): boolean {
  return ACTIVE_STATES.includes(testrun.status);
}
